module.exports = __webpack_public_path__ + "img/banner2026.e8bc058c.jpg";